import React from "react";
import Sidenav from "../../Navbar";
import ReactTyped from "react-typed";
import AdvProduct1 from "../../Images/PRODUCTS_IMG/ADVDIARY/PROD_E1.png";
import AdvProduct2 from "../../Images/PRODUCTS_IMG/ADVDIARY/PROD_E2.png";
import AdvProduct3 from "../../Images/PRODUCTS_IMG/ADVDIARY/PROD_E3.png";

import JwellsProduct1 from "../../Images/PRODUCTS_IMG/JWELLERY/PROD_JW1.png";
import JwellsProduct2 from "../../Images/PRODUCTS_IMG/JWELLERY/PROD_JW2.png";
import JwellsProduct3 from "../../Images/PRODUCTS_IMG/JWELLERY/PROD_JW3.png";
import JwellsProduct4 from "../../Images/PRODUCTS_IMG/JWELLERY/PROD_JW4.png";

import AssetProduct1 from "../../Images/PRODUCTS_IMG/ASSETMANAGEMENT/PROD_ASS1.png";
import AssetProduct2 from "../../Images/PRODUCTS_IMG/ASSETMANAGEMENT/PROD_ASS2.png";
  


import webdesign from "./Webdesign.css";

function Webdesign() {
  return (
    <>
      <Sidenav navbar_title="DevComputers" />
      <div className="container text-center" style={webdesign}>
        <div className="container text-center">
          <h1 className="header-personalised-software">
            <ReactTyped
              strings={["Software's", "Customised Software's"]}
              typeSpeed={100}
              backSpeed={100}
              cursorChar="|"
              showCursor="false"Z
              loop
            />
          </h1>
          <div className="row row-style">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div
                id="carouselExampleSlidesOnly"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img src={AdvProduct1} class="img-fluid" alt="..." />
                  </div>
                  <div class="carousel-item">
                    <img src={AdvProduct2} class="d-block w-100" alt="..." />
                  </div>
                  <div class="carousel-item">
                    <img src={AdvProduct3} class="d-block w-100" alt="..." />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-12 col-md-12 ">
              <h1 className="main-heading-card">ADVOCATES DIARY</h1>
              <h6 style={{ margin: 5 + "vh" }}>
                A best Case Management Software which you can ever have which
                can be accessible everywhere around the globe with your key and
                password!!
              </h6>
              <h6 style={{ margin: 5 + "vh" }}>
                <b>No Dataloss because u have Cloud.</b>
              </h6>
              <div className="container text-center">
              <a target=""  className="btn btn-primary mt-4" href="https://wa.me/+917742363630?text=I%20am%20interested%20in%20the%20demo%20you%20offer.">
                  Call for Demo !!
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="container text-center">
          
          <div className="row row-style">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div
                id="carouselExampleSlidesOnly"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img src={JwellsProduct1} class="img-fluid" alt="..." />
                  </div>
                  <div class="carousel-item">
                    <img src={JwellsProduct2} class="d-block w-100" alt="..." />
                  </div>
                  <div class="carousel-item">
                    <img src={JwellsProduct3} class="d-block w-100" alt="..." />
                  </div>
                  <div class="carousel-item">
                    <img src={JwellsProduct4} class="d-block w-100" alt="..." />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-12 col-md-12 ">
              <h1 className="main-heading-card">JEWELLER'S ERP/STOCK</h1>
              <h6 style={{ margin: 5 + "vh" }}>
                A best Software for the Jewellers who need a proper HISAB management of their employees all at real-time!!
              </h6>
              <h6 style={{ marginTop: 5 + "vh" }}>
                <b>No Dataloss because u have Cloud.</b>
              </h6>
              <div className="container text-center">
                <a target=""  className="btn btn-primary mt-4" href="https://wa.me/+917742363630?text=I%20am%20interested%20in%20the%20demo%20you%20offer.">
                  Call for Demo !!
                </a>
              </div>
            </div>
          </div>
        </div>


        <div className="container text-center">
          
          <div className="row row-style">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div
                id="carouselExampleSlidesOnly"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img src={AssetProduct1} class="img-fluid" alt="..." />
                  </div>
                  <div class="carousel-item">
                    <img src={AssetProduct2} class="d-block w-100" alt="..." />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-12 col-md-12 ">
              <h1 className="main-heading-card">STOCKS MANAGEMENT</h1>
              <h6 style={{ margin: 5 + "vh" }}>
                A best STOCK MANAGER for Factory , Stores to manage their stocks items with pricing and depriciation!!
              </h6>
              <h6 style={{ marginTop: 5 + "vh" }}>
                <b>All at cloud with ease.</b>
              </h6>
              <div className="container text-center">
                <a target=""  className="btn btn-primary mt-4" href="https://wa.me/+917742363630?text=I%20am%20interested%20in%20the%20demo%20you%20offer.">
                  Call for Demo !!
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Webdesign;
